/** Плашки свежести ответов «WB: регионы» — общие для шапки страницы и боковых карточек: «сборка
 *  не прошла» (`build_late`, жёлтая, цифры показываются), «данные другой сборки» (`other_build` с
 *  причинами), «ответы разных сборок» — `state.built_at` показанных ответов не совпал (meta,
 *  регионы, офферы, карточка кэшируются отдельно и могут прийти из разных сборок): тогда весь кэш
 *  раздела сбрасывается и перезапрашивается (`useBuildSync`), плашка — пока не сойдётся. */
import React from "react";

import { fmtWhen } from "../ozon-analytics/format";
import { present, type MaybeState } from "./buildSync";

const amber =
  "rounded-md border border-amber-300 bg-amber-50 px-3 py-1.5 text-xs text-amber-900 dark:border-amber-800 dark:bg-amber-950 dark:text-amber-300";

export function BuildBanners({
  states,
  mixed,
}: {
  /** свежесть показанных ответов — плашки по любому из них */
  states: MaybeState[];
  /** сборки показанных ответов, если их больше одной (`useBuildSync`) */
  mixed: string[] | null;
}): React.ReactElement | null {
  const list = present(states);
  const late = list.find((s) => s.build_late);
  const reasons = [...new Set(list.flatMap((s) => (s.other_build ? s.other_build_reasons : [])))];
  const otherBuild = list.some((s) => s.other_build);
  if (!late && !otherBuild && !mixed) return null;
  return (
    <div className="space-y-2">
      {late && (
        <div role="status" className={amber} data-testid="build-late">
          Сборка сегодня не прошла — данные от {fmtWhen(late.built_at)}.
        </div>
      )}
      {otherBuild && (
        <div role="status" className={amber} data-testid="other-build">
          Данные другой сборки: витрины собраны в разное время — цифры таблиц могут не сходиться.
          {reasons.length > 0 && (
            <ul className="mt-1 list-disc pl-5">
              {reasons.map((r) => (
                <li key={r}>{r}</li>
              ))}
            </ul>
          )}
        </div>
      )}
      {mixed && (
        <div role="status" className={amber} data-testid="mixed-builds">
          Ответы на экране — из разных сборок ({mixed.map((b) => fmtWhen(b)).join(" и ")}): цифры могут не
          сходиться; данные раздела перезапрошены.
        </div>
      )}
    </div>
  );
}
